export default {
    addToCart(state, payload) {
        state.cart.reverse();
        state.cart.push(payload);
        state.cart.reverse();
        // console.log('add to cart - ' + JSON.stringify(state.cart));
    },

    kitToCart(state, payload) {
        // console.log(payload);
        state.kits.reverse();
        state.kits.push(payload);
        state.kits.reverse();
    },
    updateCart(state, payload) {
        state.cart = payload;
        // console.log('update cart - ' + JSON.stringify(state.cart));
    },

    emptyCart(state) {
        state.cart = [];
        state.ordernotes = '';
        state.promo_code = [];
    },
    emptyPromo(state) {
        state.promo_code = [];
    },
    removeCartLine(state, payload) {
        state.cart.splice(payload.index, 1);

        // clear the promo code if the cart and kits are empty
        if(state.cart.length == 0 && state.kits.length == 0)
            state.promo_code = [];
    },
    emptyKits(state) {
        state.kits = [];
    },
    removeKitLine(state, payload) {
        state.kits.splice(payload.index, 1);

        // clear the promo code if the cart and kits are empty
        if(state.cart.length == 0 && state.kits.length == 0)
            state.promo_code = [];
    },

    updateKitComponent(state, payload){
        let kit_master = state.kits[payload.km_index];
        // console.log(kit_master);
        let currentrow = kit_master.kit_items[payload.kc_index];
        // console.log(currentrow);

        currentrow.yourprice = payload.yourprice;
        currentrow.listprice = payload.listprice;
        currentrow.corecharge = payload.corecharge;
        currentrow.linetotal = payload.linetotal;
    },
    
    totals(state, payload) { 
        // console.log(payload);
        state.totals.push({
            subtotal: payload.subtotal,
            coretotal: payload.coretotal,
            taxtotal: payload.taxtotal,
            shippingtotal: payload.shippingtotal,
            ordertotal: payload.ordertotal,
            backordered_total: payload.backordered_total,
            shipping_handling_total: payload.shipping_handling_total,
            discounttotal: payload.discounttotal,
            order_notes: payload.order_notes
        });

    },
    promocode(state, payload) {
        state.promocode = payload.promocode;
    },
    email(state, payload) {
        state.billingemail = payload.email;
        state.shippingemail = payload.email;
    },
    phone(state, payload) {
        state.billingphone = payload.phone;
        state.shippingphone = payload.phone;
    },
    billingdetails(state, payload) {
        state.email = payload.email;
        state.phone = payload.phone;
        state.billingname = payload.billingname 
        state.billingaddress1 = payload.billingaddress1 
        state.billingaddress2 = payload.billingaddress2 
        state.billingcity = payload.billingcity 
        state.billingstate = payload.billingstate 
        state.billingcountry = payload.billingcountry 
        state.billingzip = payload.billingzip 
        state.billingphone = payload.billingphone 

        // console.log('billing details - ' + state.email + ' - ' + state.phone + ' - ' +             state.billingname + ' - ' +             state.billingaddress1 + ' - ' +             state.billingaddress2 + ' - ' +             state.billingcity + ' - ' +             state.billingstate + ' - ' +             state.billingcountry + ' - ' +             state.billingzip + ' - ' +             state.billingphone);
    },
    shippingdetails(state, payload) {
        // console.log(payload);
        
        state.shippingname = payload.shippingname;
        state.shippingaddress1 = payload.shippingaddress1;
        state.shippingaddress2 = payload.shippingaddress2;
        state.shippingcity = payload.shippingcity;
        state.shippingstate = payload.shippingstate;   
        state.shippingcountry = payload.shippingcountry;
        state.shippingzip = payload.shippingzip;
        state.shippingphone = payload.shippingphone;
        state.carrier = payload.carrier;
        state.ordernotes = payload.ordernotes;

        // console.log('shipping details - ' + state.shippingname + ' - ' + state.shippingaddress1 + ' - ' + state.shippingaddress2 + ' - ' + state.shippingcity + ' - ' + state.shippingstate + ' - ' + state.shippingcountry + ' - ' + state.shippingzip + ' - ' + state.shippingphone + ' - ' + state.carrier + ' - ' + state.ordernotes);
    },
    orderdetails(state, payload) {
        state.paymenttype = payload.paymenttype;
        state.purchaseorder = payload.purchaseorder;

        // console.log('orders details - ' + state.paymenttype + ' - ' + state.purchaseorder);
    },
    ordersuccess(state, payload) {
        state.ordernumber = payload.ordernumber;
        state.orderdate = payload.orderdate;
        state.paymentmethod = payload.paymentmethod;
    },

    order_notes(state, payload){
        state.order_notes = payload.order_notes;
    },

    cc_details(state, payload) {
        state.cc_token = payload.cc_token;
        state.cc_fname = payload.cc_fname;
        state.cc_lname = payload.cc_lname;
        state.cc_cvv = payload.cc_cvv;
        state.cc_exp_mo = payload.cc_exp_mo;
        state.cc_exp_yr = payload.cc_exp_yr;
        state.cc_address = payload.cc_address;
        state.cc_city = payload.cc_city;
        state.cc_state = payload.cc_state;
        state.cc_zip = payload.cc_zip;
        state.cc_country = payload.cc_country;
    },

    updateCartLine(state, payload) {
        let currentrow = state.cart[payload.index];

        currentrow.yourprice = payload.yourprice;
        currentrow.listprice = payload.listprice;
        currentrow.corecharge = payload.corecharge;
        currentrow.linetotal = payload.linetotal;

        // currentrow.locationid = payload.locationid;
        // currentrow.locationname = payload.locationname;
        // currentrow.locationcity = payload.locationcity;
        // currentrow.locationstate = payload.locationstate;
    },

    update_tax_rate(state, payload) {
        state.tax_rate = payload.tax_rate;
    },

    cc_saved_id(state, payload) {
        state.cc_saved_id = payload.cc_saved_id;
    },

    to_save_new_cc(state, payload) {
        state.to_save_new_cc = payload.to_save_new_cc;
    },
    
    updateShippingDiff(state, payload){
        state.shippingDifferent = payload.shippingDifferent;
    },

    po_required(state, payload){
        state.po_required = payload.po_required;
    },

    cart_expiration(state, payload){
        state.cart_expiration = payload.cart_expiration;
    },

    carrier(state, payload){
        state.carrier = payload.carrier;
    },

    ordered_items(state, payload) {
        state.ordered_items = payload;
    },

    backordered_items(state, payload) {
        state.backordered_items = payload;
    },

    empty_ordered_items(state) {
        state.ordered_items = [];
    },

    setPromo_code(state, payload) {
        state.promo_code.push(payload);
    },

    updatePromoCode(state, payload){
        state.promo_code[payload.index] = payload;
    },

    deletePromoCode(state, payload){
        // state.promo_code.find(promo => promo.sequence == payload.sequence).splice;
        console.log(payload);
        // state.promo_code.splice(payload.index, 1);
        // const toremove = state.promo_code.find(promo => promo.sequence == payload.sequence).splice;
        // console.log(toremove);
    },

    setCEDKOE(state, payload){
        state.cedkoe = payload;
    },

}